import {
  HTTP_GETBUDGETSDETAIL_FETCHING,
  HTTP_GETBUDGETSDETAIL_SUCCESS,
  HTTP_GETBUDGETSDETAIL_FAILED,
  server,
  OK,
  YES,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";
import { async } from "q";
import Axios from "axios";

export const setStateBudgetsDetailToFetching = () => ({
  type: HTTP_GETBUDGETSDETAIL_FETCHING,
});

export const setStateBudgetsDetailToSuccess = (payload) => ({
  type: HTTP_GETBUDGETSDETAIL_SUCCESS,
  payload,
});

export const setStateBudgetsDetailToFailed = (payload) => ({
  type: HTTP_GETBUDGETSDETAIL_FAILED,
});

export const clearBudgetsDetail = () => {
  return async (dispatch) => {
    dispatch(
      setStateBudgetsDetailToSuccess({
        data: [],
      })
    );
  };
};

export const getBudgetsDetail = (
  country,
  company,
  brand,
  depts,
  year,
  secid
) => {
  return async (dispatch) => {
    dispatch(setStateBudgetsDetailToFetching());

    try {
      const result = await httpClient.get(
        `${server.GETBUDGETSDETAIL_URL}/${country}/${company}/${brand}/${depts}/${year}/${secid}`
      );
      dispatch(
        setStateBudgetsDetailToSuccess({
          data: result.data,
        })
      );
      return Promise.resolve(result.data);
    } catch (error) {
      // console.log("aaaaa");
      dispatch(setStateBudgetsDetailToFailed());

      return Promise.reject(error.message);
    }
  };
};
